import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";
import { getRequest } from '../../../../api/ApiService';
import Teams from '../../../../api/Teams';
import Auth from '../../../../routes/Auth';
import { Loader } from 'react-loaders';

import ImageWellDone from '../../../../containers/assets/pf2.png';
import ImageNoTargets from '../../../../containers/assets/pf1.png';

class ResultsAreInStep4 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      isWellDone: false,
      rank: null,
      loaded: false,
    };
  }

  componentDidMount() {
    const { activeRound, rounds, resultsTeamGrading } = this.props;
    let performancePageConditions = [];

    if (activeRound === 1 || activeRound === 2) {
      performancePageConditions = [
        'stock_price_grade',
        'market_share_grade',
        'revenues_grade',
        'gross_margin_grade',
      ];
    } else if (activeRound === 3) {
      performancePageConditions = [
        'revenues_grade',
        'gross_margin_grade',
        'roe_grade',
        'roa_grade',
      ];
    } else if (activeRound === 4) {
      performancePageConditions = [
        'roe_grade',
        'roa_grade',
        'earnings_per_share_grade',
        'stock_price_grade',
      ];
    }

    let isWellDone = true;
    if (
      resultsTeamGrading[performancePageConditions[0]] === 1
      || resultsTeamGrading[performancePageConditions[1]] === 1
      || resultsTeamGrading[performancePageConditions[2]] === 1
      || resultsTeamGrading[performancePageConditions[3]] === 1
    ) {
      isWellDone = true;
    } else {
      isWellDone = false;
    }

    let loaded = true;
    if (isWellDone) {
      loaded = false;
      const gameId = Number(Auth.getGameId());
      const team = Teams.currentTeam();
      const teamId = Number(team.id);
      const roundNumber = Number(activeRound);
      const round = rounds.find(i => Number(i.number) === 1);
      const roundId = round ? Number(round.id) : 0;

      getRequest(`${process.env.REACT_APP_API_URL}v2/games/teamgradings/?round=${roundId}&game=${gameId}&team=${teamId}`)
        .then(res2 => {
          let rank = null;
          if (res2.body && res2.body.results) {
            const data = res2.body.results.find(i => (
              Number(i.game) === gameId
              && Number(i.round_number) === roundNumber
              && Number(i.team) === teamId
            ));

            if (data && data.ranking) {
              rank = data.ranking;
            }
          }

          this.setState({
            rank,
            loaded: true,
          });
        })
        .catch(err2 => { });
    }

    this.setState({
      isWellDone,
      loaded,
    });
  }

  render() {
    const { isWellDone, loaded } = this.state;

    const imageSrc = isWellDone ? ImageWellDone : ImageNoTargets;

    return loaded ? (
      <OneVisualLayout
        section="RESULTS ARE IN!"
        title="Understanding Your Performance"
        paragraph1={isWellDone ? (
          <Fragment>
            Well done! Your team hit some of the financial targets! Let's walk through each metric and target to help you better understand what your team did well and what can be improved.
          </Fragment>
        ) : (
          <Fragment>
            Your team did not hit any of the financial targets this round. Let’s walk through each metric & target to help you better understand what you did well and what can be improved.
          </Fragment>
        )}
        visual={(
          <img src={imageSrc} alt="preview" />
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default ResultsAreInStep4;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/results-are-in/step4.js